import * as amplitude from "@amplitude/analytics-browser"

export default async function analyticsError(source: string, message: string) {
  await amplitude.track("Marketing Error", {
    Error: source,
    Message: message,
  }).promise
}
